import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";
import ar from "./locales/ar.json";
import fr from "./locales/fr.json";
import es from "./locales/es.json";
import pt from "./locales/pt.json";
import vi from "./locales/vi.json";
import id from "./locales/id.json";
import ms from "./locales/ms.json";
import OVERRIDES from "./overrides";
import { buildMarkets } from "./markets";

// To add a language: create locales/<code>.json, add an entry here, add the import above.
export const SUPPORTED = [
  { code: "en", name: "English", native: "English", dir: "ltr" },
  { code: "ar", name: "Arabic", native: "العربية", dir: "rtl" },
  { code: "fr", name: "French", native: "Français", dir: "ltr" },
  { code: "es", name: "Spanish", native: "Español", dir: "ltr" },
  { code: "pt", name: "Portuguese", native: "Português", dir: "ltr" },
  { code: "vi", name: "Vietnamese", native: "Tiếng Việt", dir: "ltr" },
  { code: "id", name: "Indonesian", native: "Bahasa Indonesia", dir: "ltr" },
  { code: "ms", name: "Malay", native: "Bahasa Melayu", dir: "ltr" },
];

export const NON_EN = SUPPORTED.filter((l) => l.code !== "en");
export const LANG_CODES = SUPPORTED.map((l) => l.code);

// Country → suggested language. Only a supporting signal: a stored choice or the
// browser language always wins.
export const COUNTRY_LANG = {
  SA: "ar", AE: "ar", KW: "ar", QA: "ar", BH: "ar", OM: "ar", JO: "ar", IQ: "ar",
  EG: "ar", LY: "ar", SD: "ar", YE: "ar", PS: "ar", LB: "ar", SY: "ar",
  FR: "fr", MA: "fr", TN: "fr", DZ: "fr", SN: "fr", CI: "fr", CM: "fr", BF: "fr",
  ML: "fr", NE: "fr", GN: "fr", TD: "fr", CG: "fr", GA: "fr", BJ: "fr", TG: "fr",
  RW: "fr", BI: "fr", CD: "fr", MU: "fr", MC: "fr",
  ES: "es", MX: "es", CO: "es", PE: "es", CL: "es", AR: "es", VE: "es", EC: "es",
  GT: "es", BO: "es", PY: "es", UY: "es", DO: "es", PA: "es", CR: "es",
  BR: "pt", PT: "pt", AO: "pt", MZ: "pt",
  VN: "vi",
  ID: "id",
  MY: "ms", BN: "ms",
};

export const STORAGE_KEY = "stige-lang";
export const DISMISS_KEY = "stige-lang-dismissed";

const isObj = (v) => v && typeof v === "object" && !Array.isArray(v);

// Deep merge; a plain object applied to an array merges by numeric index.
const merge = (target, source) => {
  if (Array.isArray(target) && isObj(source)) {
    const out = [...target];
    Object.entries(source).forEach(([k, v]) => {
      out[Number(k)] = merge(out[Number(k)], v);
    });
    return out;
  }
  if (isObj(target) && isObj(source)) {
    const out = { ...target };
    Object.entries(source).forEach(([k, v]) => {
      out[k] = merge(target[k], v);
    });
    return out;
  }
  return source === undefined ? target : source;
};

const BASE = { en, ar, fr, es, pt, vi, id, ms };
const build = (code) => merge(merge(BASE[code], OVERRIDES[code]), buildMarkets(code, BASE[code]));

i18n.use(initReactI18next).init({
  resources: Object.fromEntries(LANG_CODES.map((c) => [c, { translation: build(c) }])),
  lng: "en",
  fallbackLng: "en",
  returnEmptyString: false,
  interpolation: { escapeValue: false },
});

export default i18n;
